<template>
  <div class="manage-page">
    <header></header>
    <div class="header">
      <main-header></main-header>
    </div>
    <div class="side-nav-menu">
      <el-menu mode="vertical"
               @select="handleSelect"
               background-color="#E9E9EA"
               text-color="#777"
               router
               :default-active="$route.path"
      >
        <!-- :default-active="$route.path" -->

        <el-submenu index="0" v-if="deviceAuth">
          <template slot="title">
            <i class="el-icon-s-tools"></i>
            <span>{{ $t('lang.Equipment Management') }}</span>
          </template>
          <el-menu-item index="/managePage/batterySwapMgmt">{{ $t('lang.Swapping Station Management') }}</el-menu-item>
          <el-menu-item index="/managePage/batteryMgmt">{{ $t('lang.Battery Management') }}</el-menu-item>
          <!-- <el-menu-item index="/managePage/batteryManagement">{{ $t('lang.batteryManagement') }}</el-menu-item> -->
           <!-- <el-menu-item index="/managePage/electricBicycleMgmt">{{ $t('lang.Vehicle Management') }}</el-menu-item> -->
          <!-- <el-menu-item index="/managePage/deviceTrack">{{ $t('lang.Vehicle Track') }}</el-menu-item> -->
        </el-submenu>
        <!--统计-->
        <el-menu-item index="/managePage/electricityStatistics" v-if="isMenuItemAuth(THAILAND_DEVICE_ELECTRICITY_STATISTICS)">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">{{ $t('lang.Electricity Statistics') }}</span>
        </el-menu-item>
        <el-submenu index="1" v-if="orderAuth">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>{{ $t('lang.Order Management') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/managePage/chargeOrderMgmt" v-if="openCardManage">{{ $t('lang.New Card Order') }}
            </el-menu-item>
            <el-menu-item index="/managePage/chargeCabinetOrderMgmt" v-if="renewOrderManage">
              {{ $t('lang.Renewal Order') }}
            </el-menu-item>
            <el-menu-item index="/managePage/rentOrderMgmt" v-if="orderMgmtSwapOrderAuth">{{ $t('lang.Swapping Order') }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 代理商管理 -->
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-coin"></i>
            <span>{{ $t('lang.Agent Management') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index='/managePage/rechargeOrderMgmt' v-if="agentAuth">{{ $t('lang.Agent Management') }}
            </el-menu-item>
          </el-menu-item-group>

        </el-submenu>
        <!-- 组织管理 -->
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>{{ $t('lang.Organization Management') }}</span>
          </template>
          <el-menu-item-group>

            <el-menu-item index="/managePage/userMgmt" v-if="userAuth">{{ $t('lang.User Management') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-bell"></i>
            <span>{{ $t('lang.Card Management') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/managePage/warningRuleMgmt" v-if="cardAuth">{{ $t('lang.Card Management') }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="7">
          <template slot="title">
            <i class="el-icon-bell"></i>
            <span>{{ $t('lang.Operation Management') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/managePage/commodityMgmt" v-if="cardAuth">{{ $t('lang.Commodity Management') }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/managePage/downloadTask">
          <i class="el-icon-download"></i>
          <span slot="title">{{ $t('lang.Exporting Task') }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-display-area">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Utils from '../utils/utils'

const UNIT_MGMT_UNIT_QUERY_AUTH_CODE = 209;// '组织管理-组织查询'
const UNIT_MGMT_UNIT_ADD_AUTH_CODE = 218;// '组织管理-组织新增'
const UNIT_MGMT_UNIT_EDIT_AUTH_CODE = 216;// '组织管理-组织编辑'
const UNIT_MGMT_UNIT_DELETE_AUTH_CODE = 217;// '组织管理-组织删除'
const UNIT_MGMT_USER_ADD_AUTH_CODE = 219;// '组织管理-用户新增'
const UNIT_MGMT_USER_DELETE_AUTH_CODE = 220;// '组织管理-用户删除'
const UNIT_MGMT_DEVICE_ADD_AUTH_CODE = 221;// '组织管理-设备新增'
const UNIT_MGMT_DEVICE_DELETE_AUTH_CODE = 222;// '组织管理-设备删除'

const AUTHORITY_MGMT_SCHEME_QUERY_AUTH_CODE = 2;// '权限管理-方案查询'
const AUTHORITY_MGMT_SCHEME_EDIT_AUTH_CODE = 5;// '权限管理-方案编辑'
const AUTHORITY_MGMT_SCHEME_DELETE_AUTH_CODE = 7;// '权限管理-方案删除'
const AUTHORITY_MGMT_OPERATE_AUTH_CODE = 224;//'权限管理-接驳员'

const USER_MGMT_USER_QUERY_AUTH_CODE = 1;// '用户管理-用户查询'
const USER_MGMT_USER_ADD_AUTH_CODE = 3;// '用户管理-用户新增'
const USER_MGMT_USER_EDIT_AUTH_CODE = 4;// '用户管理-用户编辑'
const USER_MGMT_USER_AUDIT_AUTH_CODE = 6;// '用户管理-用户认证'

const ORDER_MGMT_SWAP_ORDER_AUTH_CODE = 201; // '订单管理-换电服务订单管理'
const ORDER_MGMT_RETURN_ORDER_AUTH_CODE = 226;// '订单管理-退还订单管理'
const ORDER_MGMT_CHARGE_ORDER_AUTH_CODE = 233;//'订单管理-充电服务订单管理'
const ORDER_MGMT_CHARGE_CABINET_ORDER_AUTH_CODE = 234;//'订单管理-充电柜充电服务订单管理'
const ORDER_MGMT_APPLY_BATTERY_ORDER_AUTH_CODE = 235;//'订单管理-申请电池订单管理'
const ORDER_MGMT_BATTERY_CONSIGN_RECORD_AUTH_CODE = 253;//'订单管理-电池寄存记录管理'

const ORDER_MGMT_RECHARGE_ORDER_AUTH_CODE = 250;//'资源中心-充值订单管理'

const DEVICE_MGMT_PILE_QUERY_AUTH_CODE = 202; // '设备管理-充电桩查询'
const DEVICE_MGMT_PILE_OPERATE_AUTH_CODE = 213; // '设备管理-充电桩操作'
const DEVICE_MGMT_PILE_EDIT_AUTH_CODE = 212; // '设备管理-充电桩编辑'
const DEVICE_MGMT_CABINET_QUERY_AUTH_CODE = 203; // '设备管理-换电柜查询'
const DEVICE_MGMT_CABINET_OPERATE_AUTH_CODE = 211; // '设备管理-换电柜操作'
const DEVICE_MGMT_CABINET_EDIT_AUTH_CODE = 210; // '设备管理-换电柜编辑'
const DEVICE_MGMT_BATTERY_QUERY_AUTH_CODE = 204; // '设备管理-电池查询'
const DEVICE_MGMT_BATTERY_STORAGE_AUTH_CODE = 214; // '设备管理-电池入库'
const DEVICE_MGMT_STATION_QUERY_AUTH_CODE = 205; // '设备管理-维护点查询'
const DEVICE_MGMT_STATION_EDIT_AUTH_CODE = 215; // '设备管理-维护点编辑'
const DEVICE_MGMT_BATTERY_CORRELATE_TO_ORDER_AUTH_CODE = 206; // '设备管理-电池关联订单投放'
const DEVICE_MGMT_BATTERY_CORRELATE_TO_CABINET_AUTH_CODE = 207; // '设备管理-电池关联换电柜投放'
const DEVICE_MGMT_CABINET_SETTING_AUTH_CODE = 208; // '设备管理-换电柜通用设置'
const DEVICE_MGMT_DISPLAY_SCREEN_AUTH_CODE = 225; // '设备管理-安卓屏管理'
const DEVICE_MGMT_CHARGE_CABINET_QUERY_AUTH_CODE = 227; // '设备管理-充电柜查询'
const DEVICE_MGMT_CHARGE_CABINET_EDIT_AUTH_CODE = 228; // '设备管理-充电柜编辑'
const DEVICE_MGMT_CHARGE_CABINET_OPERATE_AUTH_CODE = 229; // '设备管理-充电柜操作'
const DEVICE_MGMT_VOUCHER_MGMT_AUTH_CODE = 236;// '设备管理-凭证管理'
const EXCEPTION_MANAGE_AUTH_CODE = 241;//'异常配置'
const DEVICE_MGMT_ELECTRIC_BICYCLR_MGMT_AUTH_CODE = 600;//'设备管理-电动车管理'
const DEVICE_UPGRADE_AUTH_CODE = 244;//'设备管理-设备远程升级'
const DEVICE_QUERYDATASTATISTIC_AUTH_CODE = 242;//'设备管理-设备远程升级'
const DEVICE_EXPORT_RECORD_AUTH_CODE = 247;//'设备管理-导出电池流转记录'

const COMMODITY_ADD_EDIT_AUTH_CODE = 230;//'商品管理-新增编辑'
const COMMODITY_QUERY_AUTH = 231;//'商品管理-查询'
const COMMODITY_DELETE_AUTH = 232;//'商品管理-删除'
const COUPONS_ADD_EDIT_AUTH_CODE = 230;//'优惠券管理-新增编辑'
const COUPONS_QUERY_AUTH = 231;//'优惠券管理-查询'
const COUPONS_DELETE_AUTH = 232;//'优惠券管理-删除'

const SUB_ACCOUNT_ADD_AUTH = 248;//添加分账关系
const SUB_ACCOUNT_EDIT_AUTH = 249;//编辑分账关系
const SUB_ACCOUNT_DELETE_AUTH = 251;//删除分账关系
const SUB_ACCOUNT_QUERY_AUTH = 252;//查询分账关系

const MARKETING_ACTIVITY_MANAGEMENT_AUTH = 700; // 营销活动管理

//
const OPEN_CARD_MANAGE = 1031;//开卡订单管理
const RENEW_ORDER_MANAGE = 1032;//续费订单管理
const AGENT_INQUIRY = 1022;//代理商查询
//
import mainHeader from '@/components/common/mainHeader'

export default {
  name: 'managePage',

  data() {
    return {
      /**
       * 菜单权限
       */
      //统计菜单
      ELECTRICITY_STATISTICS: 1000,
      /**
       * 子菜单权限
       */
      //电量统计
      THAILAND_DEVICE_ELECTRICITY_STATISTICS: 1051,
      /**-----------------------------------------------------*/

      deviceAuth: '',
      cardAuth: '',
      agentAuth: '',
      userAuth: '',
      orderAuth: '',
      authLdata: [],
      headerFlag: true,
      authorityList: [],
      openCardManage: false,
      renewOrderManage: false,
      agentInquiry: false,

      //
      unitMgmtUnitQueryAuth: false,
      unitMgmtUnitAddAuth: false,
      unitMgmtUnitEditAuth: false,
      unitMgmtUnitDeleteAuth: false,
      unitMgmtUserAddAuth: false,
      unitMgmtUserDeleteAuth: false,
      unitMgmtDeviceAddAuth: false,
      unitMgmtDeviceDeleteAuth: false,
      unitMgmtAuth: false,

      authorityMgmtSchemeQueryAuth: false,
      authorityMgmtSchemeEditAuth: false,
      authorityMgmtSchemeDeleteAuth: false,
      authorityMgmtAuth: false,
      authorityOperatorAuth: false,

      orderMgmtSwapOrderAuth: false,
      orderMgmtAuth: false,
      orderMgmtReturnOrderAuth: false,
      orderMgmtChargeOrderAuth: false,
      orderBatterySwapCardOrderAuth: false,
      orderMgmtChargeCabinetOrderAuth: false,
      orderMgmtApplyBatteryOrderAuth: false,
      batteryConsignRecordAuth: false,
      resourceCenterAuth: false,
      orderMgmtRechargeOrderAuth: false,

      userMgmtUserQueryAuth: false,
      userMgmtUserAddAuth: false,
      userMgmtUserEditAuth: false,
      userMgmtUserAuditAuth: false,
      userMgmtAuth: false,

      deviceMgmtPileQueryAuth: false,
      deviceMgmtPileOperateAuth: false,
      deviceMgmtPileEditAuth: false,
      deviceMgmtCabinetQueryAuth: false,
      deviceMgmtCabinetOperateAuth: false,
      deviceMgmtChargeCabinetEditAuth: false,
      deviceMgmtChargeCabinetQueryAuth: false,
      deviceMgmtChargeCabinetOperateAuth: false,
      deviceMgmtCabinetEditAuth: false,
      deviceMgmtBatteryQueryAuth: false,
      deviceMgmtBatteryStorageAuth: false,
      deviceMgmtStationQueryAuth: false,
      deviceMgmtStationEditAuth: false,
      deviceMgmtBatteryCorrelateToOrderAuth: false,
      deviceMgmtBatteryCorrelateToCabinetAuth: false,
      deviceMgmtCabinetSettingAuth: false,
      deviceMgmtPileAuth: false,
      deviceMgmtCabinetAuth: false,
      deviceMgmtChargeCabinetAuth: false,
      deviceMgmtBatteryAuth: false,
      deviceUpgradeAuth: false,
      deviceDataStatisticAuth: false,
      deviceMgmtStationAuth: false,
      deviceExportRecordAuth: false,
      deviceMgmtAuth: false,
      deviceMgmtDisplayScreenAuth: false,
      deviceMgmtVoucherMgmtAuth: false,
      deviceMgmtElectricBicycleMgmtAuth: false,

      commodityAddAndEditAuth: false,
      commodityQueryAuth: false,
      commodityDeleteAuth: false,
      commodityAuth: false,
      couponsAddAndEditAuth: false,
      couponsQueryAuth: false,
      couponsDeleteAuth: false,
      couponsAuth: false,
      exceptionManageAuth: false,
      marketingActivityManageAuth: false,
      bannerManageAuth: false,
      marketingManageAuth: false,

      subAccountAddAuth: false,
      subAccountEditAuth: false,
      subAccountDeleteAuth: false,
      subAccountQueryAuth: false,

      role: 1,
      isDefaultUnit: false,
      domainType: ''
    }
  },
  computed: {
    changePassWord() {//改密码
      return this.authorityList.find(item => item === 1001);
    },
    openCard() {//卡管理-开卡
      return this.authorityList.find(item => item === 1011);
    },
    renewCard() {//卡管理-续费
      return this.authorityList.find(item => item === 1012);
    },
    agentDel() {//代理商-删除
      return this.authorityList.find(item => item === 1023);
    },
    agentAddEdit() {//代理商新增删除
      return this.authorityList.find(item => item === 1021);
    }

  },
  mounted() {
    this.$store.dispatch('queryUnitTree', {isContainRootUnit: 1});
    let domain = Utils.getDomain();
    this.queryAuthority();
    this.getBelongUnit();
  },
  methods: {
    /**
     * 判断菜单的权限
     * @param menuAuthCode
     * @return {boolean}
     */
    isMenuAuth(menuAuthCode) {
      const flag = this.authLdata.includes(menuAuthCode)
      console.log(flag)
      return flag
    },
    /**
     * 判断子菜单的权限
     * @param menuItemAuthCode
     * @return {boolean}
     */
    isMenuItemAuth(menuItemAuthCode) {
      const flag =  this.authorityList.includes(menuItemAuthCode)
      console.log(flag)
      return flag
    },

    handleSelect: function (key, keyPath) {
      // if (this.$route.path == key) {
      //     this.$nextTick(() => {
      //         this.$router.replace('/managePage/emptyPage');
      //     })
      // }
    },
    getBelongUnit() {
      let self = this;
      this.$http.post('/managementPlatform/unit/getBelongUnit').then(response => {
        let res = response.data;
        if (!res || !res.result) {
          this.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        let list = res.mdata && res.mdata.unitList;
        for (let i = 0; i < list.length; i++) {
          if (list[i].unitNo == '1560750522815424792') {
            self.isDefaultUnit = true;
            break;
          }
          if (list[i].unitNo == '1606790724195850498' && self.domainType == '2') {
            self.isDefaultUnit = true;
            break;
          }
        }
      }).catch(err => {
        console.log(err);
      });
    },
    queryAuthority() {
      let self = this;
      this.$http.post('/managementPlatform/authority/queryAuthority').then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.authorityList = res.mdata.authorityList || [];
        self.authLdata = res.ldata || [];
        self.deviceAuth = res.ldata.find(el => el === 1);
        self.cardAuth = res.ldata.find(el => el === 101);
        self.agentAuth = res.ldata.find(el => el === 102);
        self.userAuth = res.ldata.find(el => el === 2);
        self.orderAuth = res.ldata.find(el => el === 4);
        let authorityList = res.mdata.authorityList;
        let role = res.mdata.role
        let unitMgmtUnitQueryAuth = authorityList.indexOf(UNIT_MGMT_UNIT_QUERY_AUTH_CODE) > -1;
        let unitMgmtUnitAddAuth = authorityList.indexOf(UNIT_MGMT_UNIT_ADD_AUTH_CODE) > -1;
        let unitMgmtUnitEditAuth = authorityList.indexOf(UNIT_MGMT_UNIT_EDIT_AUTH_CODE) > -1;
        let unitMgmtUnitDeleteAuth = authorityList.indexOf(UNIT_MGMT_UNIT_DELETE_AUTH_CODE) > -1;
        let unitMgmtUserAddAuth = authorityList.indexOf(UNIT_MGMT_USER_ADD_AUTH_CODE) > -1;
        let unitMgmtUserDeleteAuth = authorityList.indexOf(UNIT_MGMT_USER_DELETE_AUTH_CODE) > -1;
        let unitMgmtDeviceAddAuth = authorityList.indexOf(UNIT_MGMT_DEVICE_ADD_AUTH_CODE) > -1;
        let unitMgmtDeviceDeleteAuth = authorityList.indexOf(UNIT_MGMT_DEVICE_DELETE_AUTH_CODE) > -1;
        let unitMgmtAuth = unitMgmtUnitQueryAuth || unitMgmtUnitAddAuth || unitMgmtUnitEditAuth || unitMgmtUnitDeleteAuth || unitMgmtUserAddAuth || unitMgmtUserDeleteAuth || unitMgmtDeviceAddAuth || unitMgmtDeviceDeleteAuth;

        //
        self.renewOrderManage = authorityList.indexOf(RENEW_ORDER_MANAGE) > -1;//续费订单
        self.openCardManage = authorityList.indexOf(OPEN_CARD_MANAGE) > -1;//开卡订单
        self.agentInquiry = authorityList.indexOf(AGENT_INQUIRY) > -1;//代理商查询
        //

        let authorityMgmtSchemeQueryAuth = authorityList.indexOf(AUTHORITY_MGMT_SCHEME_QUERY_AUTH_CODE) > -1;
        let authorityMgmtSchemeEditAuth = authorityList.indexOf(AUTHORITY_MGMT_SCHEME_EDIT_AUTH_CODE) > -1;
        let authorityMgmtSchemeDeleteAuth = authorityList.indexOf(AUTHORITY_MGMT_SCHEME_DELETE_AUTH_CODE) > -1;
        let authorityMgmtAuth = authorityMgmtSchemeQueryAuth || authorityMgmtSchemeEditAuth || authorityMgmtSchemeDeleteAuth;

        let userMgmtUserQueryAuth = authorityList.indexOf(USER_MGMT_USER_QUERY_AUTH_CODE) > -1;
        let userMgmtUserAddAuth = authorityList.indexOf(USER_MGMT_USER_ADD_AUTH_CODE) > -1;
        let userMgmtUserEditAuth = authorityList.indexOf(USER_MGMT_USER_EDIT_AUTH_CODE) > -1;
        let userMgmtUserAuditAuth = authorityList.indexOf(USER_MGMT_USER_AUDIT_AUTH_CODE) > -1;
        let userMgmtAuth = userMgmtUserQueryAuth || userMgmtUserAddAuth || userMgmtUserEditAuth || userMgmtUserAuditAuth;

        let orderMgmtSwapOrderAuth = authorityList.indexOf(ORDER_MGMT_SWAP_ORDER_AUTH_CODE) > -1;
        let orderMgmtReturnOrderAuth = authorityList.indexOf(ORDER_MGMT_RETURN_ORDER_AUTH_CODE) > -1;
        let orderMgmtChargeOrderAuth = authorityList.indexOf(ORDER_MGMT_CHARGE_ORDER_AUTH_CODE) > -1;
        let orderBatterySwapCardOrderAuth = authorityList.indexOf(ORDER_MGMT_SWAP_ORDER_AUTH_CODE) > -1;
        let orderMgmtChargeCabinetOrderAuth = authorityList.indexOf(ORDER_MGMT_CHARGE_CABINET_ORDER_AUTH_CODE) > -1;
        let orderMgmtApplyBatteryOrderAuth = authorityList.indexOf(ORDER_MGMT_APPLY_BATTERY_ORDER_AUTH_CODE) > -1;
        let batteryConsignRecordAuth = authorityList.indexOf(ORDER_MGMT_BATTERY_CONSIGN_RECORD_AUTH_CODE) > -1;
        let orderMgmtAuth = orderMgmtSwapOrderAuth || orderMgmtReturnOrderAuth || orderMgmtChargeOrderAuth || orderBatterySwapCardOrderAuth || orderMgmtChargeCabinetOrderAuth || orderMgmtApplyBatteryOrderAuth;

        let orderMgmtRechargeOrderAuth = authorityList.indexOf(ORDER_MGMT_RECHARGE_ORDER_AUTH_CODE) > -1;
        let resourceCenterAuth = orderMgmtRechargeOrderAuth;

        let deviceMgmtPileQueryAuth = authorityList.indexOf(DEVICE_MGMT_PILE_QUERY_AUTH_CODE) > -1;
        let deviceMgmtPileOperateAuth = authorityList.indexOf(DEVICE_MGMT_PILE_OPERATE_AUTH_CODE) > -1;
        let deviceMgmtPileEditAuth = authorityList.indexOf(DEVICE_MGMT_PILE_EDIT_AUTH_CODE) > -1;
        let deviceMgmtCabinetQueryAuth = authorityList.indexOf(DEVICE_MGMT_CABINET_QUERY_AUTH_CODE) > -1;
        let deviceMgmtCabinetOperateAuth = authorityList.indexOf(DEVICE_MGMT_CABINET_OPERATE_AUTH_CODE) > -1;
        let deviceMgmtCabinetEditAuth = authorityList.indexOf(DEVICE_MGMT_CABINET_EDIT_AUTH_CODE) > -1;
        let deviceMgmtChargeCabinetQueryAuth = authorityList.indexOf(DEVICE_MGMT_CHARGE_CABINET_QUERY_AUTH_CODE) > -1;
        let deviceMgmtChargeCabinetOperateAuth = authorityList.indexOf(DEVICE_MGMT_CHARGE_CABINET_OPERATE_AUTH_CODE) > -1;
        let deviceMgmtChargeCabinetEditAuth = authorityList.indexOf(DEVICE_MGMT_CHARGE_CABINET_EDIT_AUTH_CODE) > -1;
        let deviceMgmtBatteryQueryAuth = authorityList.indexOf(DEVICE_MGMT_BATTERY_QUERY_AUTH_CODE) > -1;
        let deviceMgmtBatteryStorageAuth = authorityList.indexOf(DEVICE_MGMT_BATTERY_STORAGE_AUTH_CODE) > -1;
        let deviceMgmtStationQueryAuth = authorityList.indexOf(DEVICE_MGMT_STATION_QUERY_AUTH_CODE) > -1;
        let deviceMgmtStationEditAuth = authorityList.indexOf(DEVICE_MGMT_STATION_EDIT_AUTH_CODE) > -1;
        let deviceMgmtBatteryCorrelateToOrderAuth = authorityList.indexOf(DEVICE_MGMT_BATTERY_CORRELATE_TO_ORDER_AUTH_CODE) > -1;
        let deviceMgmtBatteryCorrelateToCabinetAuth = authorityList.indexOf(DEVICE_MGMT_BATTERY_CORRELATE_TO_CABINET_AUTH_CODE) > -1;
        let deviceMgmtCabinetSettingAuth = authorityList.indexOf(DEVICE_MGMT_CABINET_SETTING_AUTH_CODE) > -1;
        let deviceMgmtDisplayScreenAuth = authorityList.indexOf(DEVICE_MGMT_DISPLAY_SCREEN_AUTH_CODE) > -1;
        let deviceMgmtVoucherMgmtAuth = authorityList.indexOf(DEVICE_MGMT_VOUCHER_MGMT_AUTH_CODE) > -1;
        let deviceMgmtElectricBicycleMgmtAuth = authorityList.indexOf(DEVICE_MGMT_ELECTRIC_BICYCLR_MGMT_AUTH_CODE) > -1;
        let deviceUpgradeAuth = authorityList.indexOf(DEVICE_UPGRADE_AUTH_CODE) > -1;
        let deviceDataStatisticAuth = authorityList.indexOf(DEVICE_QUERYDATASTATISTIC_AUTH_CODE) > -1;
        let deviceExportRecordAuth = authorityList.indexOf(DEVICE_EXPORT_RECORD_AUTH_CODE) > -1;
        let deviceMgmtPileAuth = deviceMgmtPileQueryAuth || deviceMgmtPileOperateAuth || deviceMgmtPileEditAuth;
        let deviceMgmtCabinetAuth = deviceMgmtCabinetQueryAuth || deviceMgmtCabinetOperateAuth || deviceMgmtCabinetEditAuth;
        let deviceMgmtChargeCabinetAuth = deviceMgmtChargeCabinetQueryAuth || deviceMgmtChargeCabinetOperateAuth || deviceMgmtChargeCabinetEditAuth;
        let deviceMgmtBatteryAuth = deviceMgmtBatteryQueryAuth || deviceMgmtBatteryStorageAuth;
        let deviceMgmtStationAuth = deviceMgmtStationQueryAuth || deviceMgmtStationEditAuth;
        let deviceMgmtAuth = deviceMgmtPileAuth || deviceMgmtCabinetAuth || deviceMgmtChargeCabinetAuth || deviceMgmtBatteryAuth || deviceMgmtStationAuth || deviceMgmtBatteryCorrelateToOrderAuth || deviceMgmtBatteryCorrelateToCabinetAuth || deviceMgmtCabinetSettingAuth || deviceMgmtDisplayScreenAuth || deviceMgmtVoucherMgmtAuth || deviceUpgradeAuth;

        let commodityAddAndEditAuth = authorityList.indexOf(COMMODITY_ADD_EDIT_AUTH_CODE) > -1;
        let commodityQueryAuth = authorityList.indexOf(COMMODITY_QUERY_AUTH) > -1;
        let commodityDeleteAuth = authorityList.indexOf(COMMODITY_DELETE_AUTH) > -1;
        let commodityAuth = commodityAddAndEditAuth || commodityQueryAuth || commodityDeleteAuth;
        let couponsAddAndEditAuth = authorityList.indexOf(COUPONS_ADD_EDIT_AUTH_CODE) > -1;
        let couponsQueryAuth = authorityList.indexOf(COUPONS_QUERY_AUTH) > -1;
        let couponsDeleteAuth = authorityList.indexOf(COUPONS_DELETE_AUTH) > -1;
        let exceptionManageAuth = authorityList.indexOf(EXCEPTION_MANAGE_AUTH_CODE) > -1;
        let marketingActivityManageAuth = authorityList.indexOf(MARKETING_ACTIVITY_MANAGEMENT_AUTH) > -1;
        let bannerManageAuth = role === 2;
        let marketingManageAuth = marketingActivityManageAuth || bannerManageAuth;
        let couponsAuth = couponsAddAndEditAuth || couponsQueryAuth || couponsDeleteAuth;

        let subAccountAddAuth = authorityList.indexOf(SUB_ACCOUNT_ADD_AUTH) > -1;
        let subAccountEditAuth = authorityList.indexOf(SUB_ACCOUNT_EDIT_AUTH) > -1;
        let subAccountDeleteAuth = authorityList.indexOf(SUB_ACCOUNT_DELETE_AUTH) > -1;
        let subAccountQueryAuth = authorityList.indexOf(SUB_ACCOUNT_QUERY_AUTH) > -1;

        self.unitMgmtUnitQueryAuth = unitMgmtUnitQueryAuth;
        self.unitMgmtUnitAddAuth = unitMgmtUnitAddAuth;
        self.unitMgmtUnitEditAuth = unitMgmtUnitEditAuth;
        self.unitMgmtUnitDeleteAuth = unitMgmtUnitDeleteAuth;
        self.unitMgmtUserAddAuth = unitMgmtUserAddAuth;
        self.unitMgmtUserDeleteAuth = unitMgmtUserDeleteAuth;
        self.unitMgmtDeviceAddAuth = unitMgmtDeviceAddAuth;
        self.unitMgmtDeviceDeleteAuth = unitMgmtDeviceDeleteAuth;
        self.unitMgmtAuth = unitMgmtAuth;

        self.authorityMgmtSchemeQueryAuth = authorityMgmtSchemeQueryAuth;
        self.authorityMgmtSchemeEditAuth = authorityMgmtSchemeEditAuth;
        self.authorityMgmtSchemeDeleteAuth = authorityMgmtSchemeDeleteAuth;
        self.authorityMgmtAuth = authorityMgmtAuth;

        self.orderMgmtSwapOrderAuth = orderMgmtSwapOrderAuth;
        self.orderMgmtAuth = orderMgmtAuth;
        self.orderMgmtReturnOrderAuth = orderMgmtReturnOrderAuth;
        self.orderMgmtChargeOrderAuth = orderMgmtChargeOrderAuth;
        self.orderBatterySwapCardOrderAuth = orderBatterySwapCardOrderAuth;
        self.orderMgmtChargeCabinetOrderAuth = orderMgmtChargeCabinetOrderAuth;
        self.orderMgmtApplyBatteryOrderAuth = orderMgmtApplyBatteryOrderAuth;
        self.batteryConsignRecordAuth = batteryConsignRecordAuth;

        self.orderMgmtRechargeOrderAuth = orderMgmtRechargeOrderAuth;
        self.resourceCenterAuth = resourceCenterAuth;

        self.userMgmtUserQueryAuth = userMgmtUserQueryAuth;
        self.userMgmtUserAddAuth = userMgmtUserAddAuth;
        self.userMgmtUserEditAuth = userMgmtUserEditAuth;
        self.userMgmtUserAuditAuth = userMgmtUserAuditAuth;
        self.userMgmtAuth = userMgmtAuth;

        self.deviceMgmtPileQueryAuth = deviceMgmtPileQueryAuth;
        self.deviceMgmtPileOperateAuth = deviceMgmtPileOperateAuth;
        self.deviceMgmtPileEditAuth = deviceMgmtPileEditAuth;
        self.deviceMgmtCabinetQueryAuth = deviceMgmtCabinetQueryAuth;
        self.deviceMgmtCabinetOperateAuth = deviceMgmtCabinetOperateAuth;
        self.deviceMgmtChargeCabinetEditAuth = deviceMgmtChargeCabinetEditAuth;
        self.deviceMgmtChargeCabinetQueryAuth = deviceMgmtChargeCabinetQueryAuth;
        self.deviceMgmtCabinetEditAuth = deviceMgmtCabinetEditAuth;
        self.deviceMgmtBatteryQueryAuth = deviceMgmtBatteryQueryAuth;
        self.deviceMgmtBatteryStorageAuth = deviceMgmtBatteryStorageAuth;
        self.deviceMgmtStationQueryAuth = deviceMgmtStationQueryAuth;
        self.deviceMgmtStationEditAuth = deviceMgmtStationEditAuth;
        self.deviceMgmtBatteryCorrelateToOrderAuth = deviceMgmtBatteryCorrelateToOrderAuth;
        self.deviceMgmtBatteryCorrelateToCabinetAuth = deviceMgmtBatteryCorrelateToCabinetAuth;
        self.deviceMgmtCabinetSettingAuth = deviceMgmtCabinetSettingAuth;
        self.deviceMgmtPileAuth = deviceMgmtPileAuth;
        self.deviceMgmtCabinetAuth = deviceMgmtCabinetAuth;
        self.deviceMgmtChargeCabinetAuth = deviceMgmtChargeCabinetAuth;
        self.deviceMgmtBatteryAuth = deviceMgmtBatteryAuth;
        self.deviceUpgradeAuth = deviceUpgradeAuth;
        self.deviceDataStatisticAuth = deviceDataStatisticAuth;
        self.deviceMgmtStationAuth = deviceMgmtStationAuth;
        self.deviceExportRecordAuth = deviceExportRecordAuth;
        self.deviceMgmtAuth = deviceMgmtAuth;
        self.deviceMgmtDisplayScreenAuth = deviceMgmtDisplayScreenAuth;
        self.deviceMgmtVoucherMgmtAuth = deviceMgmtVoucherMgmtAuth;
        self.deviceMgmtElectricBicycleMgmtAuth = deviceMgmtElectricBicycleMgmtAuth;

        self.commodityAddAndEditAuth = commodityAddAndEditAuth;
        self.commodityQueryAuth = commodityQueryAuth;
        self.commodityDeleteAuth = commodityDeleteAuth;
        self.commodityAuth = commodityAuth;
        self.couponsAddAndEditAuth = couponsAddAndEditAuth;
        self.couponsQueryAuth = couponsQueryAuth;
        self.couponsDeleteAuth = couponsDeleteAuth;
        self.marketingActivityManageAuth = marketingActivityManageAuth;
        self.bannerManageAuth = bannerManageAuth;
        self.marketingManageAuth = marketingManageAuth;
        self.couponsAuth = couponsAuth;
        self.exceptionManageAuth = exceptionManageAuth;

        self.subAccountAddAuth = subAccountAddAuth;
        self.subAccountEditAuth = subAccountEditAuth;
        self.subAccountDeleteAuth = subAccountDeleteAuth;
        self.subAccountQueryAuth = subAccountQueryAuth;

        self.role = role;

        if (self.deviceExportRecordAuth) {
          self.$store.commit('setCanExportRecord', true);
        } else {
          self.$store.commit('setCanExportRecord', false);
        }
      }).catch(function (response) {
        console.log(response);
      });
    }
  },
  components: {
    mainHeader,
  },
}
</script>

<style lang="scss" scoped>
.manage-page {
  /deep/ .el-submenu__title {
    overflow: hidden;
    text-overflow: ellipsis;
    span {
      margin-right: 10px;
    }
  }
  /deep/ .el-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px 0 45px;
  }
  .side-nav-menu {
    position: absolute;
    left: 0;
    width: 200px;
    height:calc(100vh - 58px);
    overflow-x: hidden;
    overflow-y: auto;
    background: #E9E9EA;
  }

  .main-display-area {
    position: absolute;
    left: 200px;
    right: 0;
    height: calc(100vh - 58px);;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/managePage.vue